import View from './view.js'
import React from 'react'
import {
  useDataIsSubmitting,
  useDataValue,
  useDataOriginalValue,
} from 'Simple/Data'
import isEqual from 'lodash/isEqual.js'

export default function Logic(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'settings',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'settings',
    viewPath: props.viewPath,
  })

  let originalValue = useDataOriginalValue({
    context: 'settings',
    viewPath: props.viewPath,
  })

  return (
    <View {...props} disabled={isSubmitting || isEqual(value, originalValue)} />
  )
}
